import { render, staticRenderFns } from "./EquipmentDefects.vue?vue&type=template&id=2b37bce6&scoped=true"
import script from "./EquipmentDefects.vue?vue&type=script&lang=js"
export * from "./EquipmentDefects.vue?vue&type=script&lang=js"
import style0 from "./EquipmentDefects.vue?vue&type=style&index=0&id=2b37bce6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b37bce6",
  null
  
)

export default component.exports